import ReactDOM from 'react-dom/client';
import 'normalize.css';
import './index.scss';
import App from './components/main/App';
import reportWebVitals from './reportWebVitals';
import { AuthProvider } from './components/security/AuthContext';
import 'normalize.css';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <AuthProvider>
    <App />
  </AuthProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
